/* eslint-disable no-console */
function openBlock(element, helperBlock){
    if(element != null && !element.classList.contains("opened")){
            var sectionHeight = element.scrollHeight;
            element.style.height = sectionHeight + 'px';
            element.style.margin = "10px 0 40px 0";
            element.addEventListener('transitionend', function(e) {
                element.removeEventListener('transitionend', arguments.callee);
                element.style.height = "auto";
                element.classList.add("opened");
            });
            if(helperBlock != null){
                helperBlock.classList.add("opened");
            }
    }
}
function closeBlock(element, helperBlock){
    var sectionHeight = element.scrollHeight - 50;
    var elementTransition = element.style.transition;
    element.style.transition = '';
    requestAnimationFrame(function() {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;
        requestAnimationFrame(function() {
            element.style.height = 0 + 'px';
            element.style.margin = "0";
        });
    });
    element.classList.remove("opened");
    if(helperBlock != null){
        helperBlock.classList.remove("opened");
    }
}

function toggleOpenBlock(buttonElements, buttonElement) {
    var sameGroupElements = document.getElementsByClassName(buttonElement.dataset.group);
    for(var i=0; i<sameGroupElements.length; i++){
    	if(sameGroupElements[i] !== document.getElementsByClassName(buttonElement.dataset.block)[0]){
            closeBlock(sameGroupElements[i], null);
    	}
    }
    for(var i=0; i<buttonElements.length; i++){
    	if(buttonElements[i] !== buttonElement){
    		if(buttonElement.dataset.group === buttonElements[i].dataset.group){
    			buttonElements[i].classList.remove('opened');
    		}
    	}
    }
    var infoBlock = document.getElementsByClassName(buttonElement.dataset.block)[0];
    if(infoBlock.classList.contains('opened')){
        closeBlock(infoBlock, buttonElement);
    }else{
        openBlock(infoBlock, buttonElement);
    }
}

document.addEventListener('DOMContentLoaded', function () {
    var url = window.location.href;
    var anchor = "";
    if(url.indexOf("#") != -1){
        anchor = url.substring(url.indexOf("#")+1)
    }


	var buttonElements = document.querySelectorAll('.wp-block-exe-toggle-info-block');
	if (buttonElements) {
		buttonElements.forEach(function (buttonElement) {
			buttonElement.addEventListener('click', function (){
			    if(buttonElement.dataset.link == ""){
    			    toggleOpenBlock(buttonElements, buttonElement);
                }else{
                    window.location.assign(buttonElement.dataset.link);
                }
            });

            if(buttonElement.dataset.anchor != "" && buttonElement.dataset.anchor == anchor){
                toggleOpenBlock(buttonElements, buttonElement)
            }

		});
	}
});
/* eslint-enable no-console */
